<template>
	<div class="custom_success_page_popup_wrap">
		<div class="success_icon_wrap">
			<svg class="icon" aria-hidden="true">
				<use xlink:href="#icon-chenggong" />
			</svg>
		</div>
		<div class="success_text">您已提交成功</div>
	</div>
</template>

<script>
export default {
	name: 'CustomSuccessPage',
	data() {
		return {};
	},
};
</script>

<style lang="less">
.custom_success_page_popup_wrap {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 1);
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	.success_icon_wrap {
		display: flex;
		justify-content: center;
		align-items: center;
		.icon {
			width: 80px;
			height: 80px;
			font-size: 80px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	.success_text {
		margin-top: 32px;
		font-size: 18px;
		color: #07d79c;
	}
}
</style>
